import { withInstall } from '@ll-plus/utils'

import AutoComplete from './src/auto-complete.vue'

export const LlAutoComplete = withInstall(AutoComplete)

export * from './src/auto-complete'

declare module 'vue' {
  export interface GlobalComponents {
    LlAutoComplete: typeof AutoComplete
  }
}
